import { ReadonlyURLSearchParams } from 'next/navigation';

import { handleServiceClick } from '@libs/experience-api';

export const handleRedirectToServices = (searchParams: ReadonlyURLSearchParams | null) => {
    let redirectUrl = searchParams?.get('redirectUrl') ?? null;

    if (!redirectUrl) {
        return;
    }
    const url = new URL(redirectUrl);

    const paramsToCopy = ['serviceType', 'apptId', 'petUUID', 'invoiceId', 'i', 'e', 'serviceId'] as const;
    paramsToCopy.forEach(key => {
        const value = searchParams?.get(key);
        if (value) url.searchParams.set(key, value);
    });

    redirectUrl = url.toString();

    handleServiceClick({
        authType: 'velocity',
        event: null,
        link: redirectUrl,
    });
};
